import TriggerConfig from 'eflex/models/trigger-config';

export default class EdhrTriggerConfig extends TriggerConfig {}
